import { Phone, WifiOff } from "lucide-react";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

/** Shown whenever the booking system itself is unreachable or unauthenticated.
 * Never a blank panel and never a raw error: the phone line always works. */
export const BookingOutage = ({
  testId = "booking-outage",
  phone = WB.phone,
  phoneHref = WB.phoneHref,
  title = "Online booking is temporarily unavailable",
  compact = false,
}) => (
  <div
    data-testid={testId}
    role="status"
    className={`rounded-3xl border border-sand-border bg-white text-center ${compact ? "p-6" : "p-8 lg:p-10"}`}
  >
    <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-lake/10">
      <WifiOff className="h-5 w-5 text-lake" aria-hidden="true" />
    </span>
    <p className={`mt-4 font-display font-bold text-navy ${compact ? "text-lg" : "text-xl sm:text-2xl"}`}>
      {title}
    </p>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-600">
      Our booking system isn't responding at the moment, so we can't show live boats or times.
      The dock is still open — call us and we'll reserve your boat over the phone.
    </p>
    <a
      href={phoneHref}
      data-testid={`${testId}-call-link`}
      className="mt-6 inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-ember-hover"
    >
      <Phone className="h-4 w-4" aria-hidden="true" />
      Call {phone}
    </a>
    <p className="mt-4 text-xs text-slate-500">
      Everything else on the site still works — rates, requirements, storage and lake information.
    </p>
  </div>
);

export default BookingOutage;
